import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-explorewgt',
  templateUrl: './explorewgt.component.html',
  styleUrls: ['./explorewgt.component.css']
})
export class ExplorewgtComponent implements OnInit {
  @Input() size: number;
  @Input() pageId: number;
  @Input() exploreData: any = [];
  constructor( private homepageService: HomepageService) { }
  exploreData1: any = [];
  selectedStyle: any = 'a_';
  responseAPIstatus: boolean = true;
  ngOnInit() {
    if(this.exploreData){
      var temp1:any = [];
      this.exploreData.buttons.forEach((jsn,keyJ) => {
        if(jsn.action == 'S' && jsn.target != null){
          let trgt:any = jsn.target;
          //console.log("trgt", trgt);
          trgt = this.stringToJson(trgt);
          //console.log("trgt", trgt);
          if(trgt.type == 'Boolean' || trgt.type == 'bool'){
            trgt = this.booleanJson(trgt);
          }
  
          //if(jsn.target.indexOf('{') >= 0 &&  jsn.target.indexOf('}') >= 0){
            //var trgt:any = JSON.parse(jsn.target);
          //} else {
            //var trgt:any = 'null';
          //}
          var tempd:any = {
            id:jsn.id,
            caption:jsn.caption,
            visible:jsn.visible,
            position:jsn.position,
            action:jsn.action,
            image:jsn.image,
            target:trgt
            //description:jsn.description
          }
        } else {
          var tempd:any = {
            id:jsn.id,
            caption:jsn.caption,
            visible:jsn.visible,
            position:jsn.position,
            action:jsn.action,
            image:jsn.image,
            target: (jsn.target)? jsn.target : 'null'
            //description:jsn.description
          }
        }
      temp1.push(tempd);
      });
      this.exploreData.buttons = temp1;
    }
  }
  loadExplore(pageId){
     return this.homepageService.getExploreData(pageId).subscribe(( data: any) => {
        this.exploreData = data;
        console.log(this.exploreData);
        this.convertData(data);
        this.responseAPIstatus = false;
      });
   }

   //Changinf BE response to JSON.
   stringToJson(url){
    var temp:any = [];
    var params:any = {};
    if(url){
      temp = url.split('?');
      temp.forEach(function(data, key){
        var tmp:any = [];
        if(key == 0){
          tmp = data.split('/');
          if(tmp[2] == 'basic') tmp[2] = 'Basic';
          if(tmp[2] == 'boolean') tmp[2] = 'Boolean';
          if(tmp[2] == 'barcode') tmp[2] = 'Barcode';
          if(tmp[2] == 'call') tmp[2] = 'Call';
          if(tmp[2] == 'ar') tmp[2] = 'AcceleratedReader';
          if(tmp[2] == 'fountas') tmp[2] = 'Fountas';
          if(tmp[2] == 'lexile') tmp[2] = 'Lexile';
          if(tmp[2] == 'marc') tmp[2] = 'Marc';
          if(tmp[2] == 'category') tmp[2] = 'Category';
          if(tmp[2] == 'rc') tmp[2] = 'ReadingCounts';
          params['type'] = tmp[2];
        }else{
          tmp = data.split('&');
          tmp.forEach(function(d,k){
            var tp:any = [];
            tp = d.split('=');
            params[tp[0]] = tp[0] == 'in' ? tp[1].toUpperCase() : tp[1];
          });
        }
        
      });return JSON.parse(JSON.stringify(params));
    }else{
      
    }
  }


  //convert button data to json format.
  convertData(data){
    var tempA:any = data;
    this.exploreData1 = tempA;
    //this.exploreData1.data.buttons = [];
    var temp1:any = [];
    tempA.data.buttons.forEach((jsn,keyJ) => {
      //console.log(jsn);
      if(jsn.action == 'S' && jsn.target != null){
        var trgt:any = jsn.target;
        trgt = this.stringToJson(trgt);
        if(trgt.type == 'Boolean' || trgt.type == 'bool'){
          trgt = this.booleanJson(trgt);
        }
        var tempd:any = {
          id:jsn.id,
          caption:jsn.caption,
          visible:jsn.visible,
          position:jsn.position,
          action:jsn.action,
          image:jsn.image,
          target:trgt
        }
      } else {
        var tempd:any = {
          id:jsn.id,
          caption:jsn.caption,
          visible:jsn.visible,
          position:jsn.position,
          action:jsn.action,
          image:jsn.image,
          target: (jsn.target)? jsn.target : 'null'
        }
      }
    temp1.push(tempd);
    });
    //console.log(temp1);
    this.exploreData1 = temp1;
    //console.log(this.exploreData1);
  }
  
  //Checking boolean search parameters...
  booleanJson(url){
    //console.log("url", url);
    var params:any = {};
    params['type'] = (url.type == 'bool') ? 'Boolean' : url.type;
    params['count'] = url.count;
    params['operators'] = [];
    for(var i = 1; i <= url.count; i++){
      var temp:any = {
        'op':url['op-'+i] ? url['op-'+i] : 'and',
        'term':url['term-'+i]? url['term-'+i] : '' ,
        'in':url['in-'+i] ? url['in-'+i] : url['by-'+i] ? url['by-'+i] : '',
      }
      params['operators'].push(temp);
    }
    if("l-cat" in url){
      params["l-cat"] = url["l-cat"];
    }
    if("l-inlib" in url) {
      params["l-inlib"] = url["l-inlib"];
    }
    if("l-lexmin" in url) {
      params["l-lexmin"] = url["l-lexmin"];
      params["l-lexmax"] = url["l-lexmax"];
      params["l-lexcode"] = url["l-lexcode"];
      params["l-lexpat"] = url["l-lexpat"];
    }
    if("l-armin" in url) {
      params["l-armin"] = url["l-armin"];
      params["l-armax"] = url["l-armax"];
      params["l-arminpt"] = url["l-arminpt"];
      params["l-armaxpt"] = url["l-armaxpt"];
      params["l-arint"] = url["l-arint"];
    }
    if("l-rcmin" in url) {
      params["l-rcmin"] = url["l-rcmin"];
      params["l-rcmax"] = url["l-rcmax"];
      params["l-rcminpt"] = url["l-rcminpt"];
      params["l-rcmaxpt"] = url["l-rcmaxpt"];
    }
    if("l-fpmin" in url) {
      params["l-fpmin"] = url["l-fpmin"];
      params["l-fpmax"] = url["l-fpmax"];
    }
    return JSON.parse(JSON.stringify(params));
  }

  //This will create the modern url.
  queryToJsonTest(queryStringReview: any){
    const params = new URLSearchParams(new URL(queryStringReview, 'http://library.site').search);
    const minRate = params.get('minrate');
    const reviewAge = params.get('reviewage');
    const reviewerName = params.get('reviewername');
    const categories = params.get('categories');
    var urlParams:any = {
      minrate: minRate || '',
      reviewage: reviewAge || '',
      reviewername: reviewerName || '',
      categories: categories || '',
    };
    return urlParams;
  }

  queryToJson(url){
    var urlParams:any = {};
    var temp:any = [];
    var parameter: string = '';
    if(url.type == 'Boolean' ){
      urlParams.type = url.type;
      urlParams.count = url.count;
      url.operators.forEach((data,key) =>{
        parameter += 'term-'+(key+1)+ '='+ data.term+'&';
        parameter += 'in-'+(key+1)+'='+ data.in+'&';
        parameter += 'op-' + (key + 1) + '=' + (data.op) + (key + 1 !== url.operators.length ? '&' : '');
      });         
      if("l-cat" in url){
        parameter +="&l-cat="+url["l-cat"];
      }
      if("l-inlib" in url) {
        parameter +="&l-inlib="+url["l-inlib"];
      }
      if("l-lexmin" in url) {
        parameter += "&l-lexmax="+url["l-lexmax"];
        parameter += "&l-lexmin="+url["l-lexmin"];
        parameter += "&l-lexcode="+url["l-lexcode"];
        parameter += "&l-lexpat="+url["l-lexpat"];
      }
      if("l-armin" in url) {
        parameter += "&l-armin="+ url["l-armin"];
        parameter += "&l-armax="+ url["l-armax"];
        parameter += "&l-arminpt="+ url["l-arminpt"];
        parameter += "&l-armaxpt="+ url["l-armaxpt"];
        parameter += "&l-arint="+ url["l-arint"];
      }
      if("l-rcmin" in url) {
        parameter += "&l-rcmin="+ url["l-rcmin"];
        parameter += "&l-rcmax="+ url["l-rcmax"];
        parameter += "&l-rcminpt="+ url["l-rcminpt"];
        parameter += "&l-rcmaxpt="+ url["l-rcmaxpt"];
      }
      if("l-fpmin" in url) {
        parameter += "&l-fpmin="+ url["l-fpmin"];
        parameter += "&l-fpmax="+ url["l-fpmax"];
      }
      urlParams['parameters'] = parameter;
      } else {
      urlParams = url;  
    }
    if(url.type == 'Marc'){
      if(url.exact == 'y')
      url.exact = true;
      if(url.exact == 'n')
      url.exact = false;
    }
    return urlParams;
  }

  //This will create the modern url.
  stringToQuerySearchReviewUrl(queryStringReview){
    console.log(queryStringReview);
    const params = new URLSearchParams(new URL(queryStringReview, 'http://library.site').search);
    const minRate = params.get('minrate');
    const reviewAge = params.get('reviewage');
    const reviewerName = params.get('reviewername');
    const categories = params.get('categories');
    var urlParams:any = {
      minrate: minRate || '',
      reviewage: reviewAge || '',
      reviewername: reviewerName || '',
      categories: categories || '',
    };
    return urlParams;
  }
}
